module.exports = "data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="


//////////////////
// WEBPACK FOOTER
// ./node_modules/fancybox-plus/images/fbplus/blank.gif
// module id = 931
// module chunks = 0